export default {
    methods: {
        onlyEnglish(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if(/^[A-Za-z]+$/.test(char)) return true; // Match with regex 
        else e.preventDefault(); // If not match, don't add to input text
      },
        onlyEnglishNum(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if(/^[0-9]+$/.test(char)) return true; // Match with regex 
        // if(/^[1-9](,[1-9])+$/.test(char)) return true; // Match with regex 
        else e.preventDefault(); // If not match, don't add to input text
      },
        preventNumbers(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if(/^[0-9]+$/.test(char) || /^[0-9]+$/.test(e.key)) e.preventDefault();  // Match with regex 
        else return true;// If not match, don't add to input text
      },


        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },


      p2eNums(e) {
        
        return e.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))}
      //   notNumber(e) {
      //     // console.log(e);
      //   let char = String.fromCharCode(e.); // Get the character
      //   if(!(/^([^0-9]*)$/.test(char))) return true; // Match with regex 
      //   else e.preventDefault(); // If not match, don't add to input text
      // }
    }
}